import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { of as observableOf } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

import { VisitorService, Visitor, VisitorStats } from '../services/visitor.service';
import { Exhibitor } from '../services/exhibitor.service';

import { environment } from '../../environments/environment';

/**
 * Default child of /home. Holds the stats grid + visitor/exhibitor tables that
 * previously lived in DashboardComponent. The dashboard shell now hosts the
 * header/footer and the routed outlets; row clicks open the edit/exedit detail
 * pages in the named `detail` outlet (the slide-over sidenav).
 */
@Component({
  templateUrl: './dashboard-home.component.html',
  styleUrls: ['./dashboard.component.scss'],
})
export class DashboardHomeComponent implements OnInit {
  activeTab: 'visitors' | 'exhibitors' | 'videos' = 'visitors';

  stats: VisitorStats;

  _eventYear = environment.event_year;
  _veranstalter = environment.veranstalter;

  constructor(private visitorService: VisitorService, private router: Router, private route: ActivatedRoute) {}

  ngOnInit() {
    this.loadVisitorStats();
  }

  loadVisitorStats(): void {
    this.visitorService
      .getVisitors(1, 100, 't_visitorid', 'asc', '', '')
      .pipe(
        catchError(() => observableOf(null)),
        map((res) => res?.stats)
      )
      .subscribe((stats) => {
        if (stats) {
          this.stats = stats;
        }
      });
  }

  showPageDetailVisitor(visitor: Visitor) {
    // visitor edit uses the client-specific firststart variant
    const target = environment.client === 'french-rendez-vous' ? 'edit-frv' : 'edit-wf';
    this.router.navigate(
      [
        {
          outlets: {
            detail: [target, { id: visitor.t_visitorid, _uid: visitor.beuser_id, _fid: visitor.t_visitorid, _role: 3, _country: visitor.country, ia: 1 }],
          },
        },
      ],
      { relativeTo: this.route.parent }
    );
  }

  showPageDetailExhibitor(exhibitor: Exhibitor) {
    this.router.navigate(
      [
        {
          outlets: {
            detail: [
              'exedit',
              {
                id: exhibitor.t_exhibitorid,
                _uid: exhibitor.beuser_id,
                _fid: exhibitor.t_exhibitorid,
                _role: 2,
                _country: exhibitor.fax,
                ia: 1,
                opensrc: 'edit',
              },
            ],
          },
        },
      ],
      { relativeTo: this.route.parent }
    );
  }
}
